import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default abstract class NavigationController extends Controller {
  abstract queryParams: string[];

  @tracked fromBreadcrumb?: string | null;
}
